import React from 'react';

import EndSurveyBackground from '../../../../assets/img/web-survey/EndSurveyBackground';
import MobileBottomBackgroundBlob from '../../../../assets/img/web-survey/MobileBottomBackgroundBlob';

import herdyCheering from '../../../../assets/img/herdy-cheering.svg';
import herdyOnShouldersWithIcecream from '../../../../assets/img/herdy-on-shoulders-with-icecream.svg';
import surveyOnPhoneDutch from '../../../../assets/img/survey-on-phone-Dutch.png';
import surveyOnPhoneFrench from '../../../../assets/img/survey-on-phone-French.png';
import surveyOnPhoneEnglish from '../../../../assets/img/survey-on-phone-English.png';
import herdyStanding from '../../../../assets/img/herdy-standing.svg';
import herdyStandingArm from '../../../../assets/img/herdy-standing-arm.svg';
import herdySittingIcecream from '../../../../assets/img/herdy-sitting-icecream.svg';

import styles from './EndSurveyImages.module.css';

export default props => {
  const {
    page,
    hideDownloadBufflInWebSurvey,
    hideIllustrationsInWebSurvey,
    customThemeBaseColor
  } = props;

  const pages = {
    COMPLETED: 'COMPLETED',
    NOT_AVAILABLE: 'NOT_AVAILABLE',
    NOT_ELIGIBLE: 'NOT_ELIGIBLE'
  };

  let surveyOnPhoneImage = surveyOnPhoneDutch;
  const language = localStorage.getItem('campaignLanguage');
  if (language === 'Dutch') {
    surveyOnPhoneImage = surveyOnPhoneDutch;
  } else if (language === 'English') {
    surveyOnPhoneImage = surveyOnPhoneEnglish;
  } else if (language === 'French') {
    surveyOnPhoneImage = surveyOnPhoneFrench;
  }

  return (
    <div className={styles.endSurveyBackgroundContainer}>
      <div alt="End survey background" className={styles.endSurveyBackground}>
        <EndSurveyBackground fillColor={customThemeBaseColor} />
      </div>
      <div
        alt="Mobile bottom background blob"
        className={styles.mobileBottomBackgroundBlob}
      >
        <MobileBottomBackgroundBlob fillColor={customThemeBaseColor} />
      </div>
      {page === pages.NOT_ELIGIBLE &&
      !hideIllustrationsInWebSurvey &&
      !hideDownloadBufflInWebSurvey ? (
        <img
          src={herdyStanding}
          alt="Herdy standing"
          className={styles.herdyStanding}
        />
      ) : null}
      {!hideDownloadBufflInWebSurvey && !hideIllustrationsInWebSurvey ? (
        <img
          src={surveyOnPhoneImage}
          alt="BUFFL survey app on phone"
          className={`${styles.surveyOnPhone} ${
            page === pages.COMPLETED ? styles.surveyOnPhoneCompleted : ''
          }`}
        />
      ) : null}
      {page === pages.COMPLETED &&
      (!hideDownloadBufflInWebSurvey && !hideIllustrationsInWebSurvey) ? (
        <img
          src={herdyCheering}
          alt="Herdy cheering"
          className={styles.herdyCheering}
        />
      ) : null}
      {page === pages.NOT_AVAILABLE &&
      !hideDownloadBufflInWebSurvey &&
      !hideIllustrationsInWebSurvey ? (
        <img
          src={herdyOnShouldersWithIcecream}
          alt="Herdy sitting on shoulders with icecream"
          className={styles.herdyOnShouldersWithIcecream}
        />
      ) : null}
      {page === pages.NOT_ELIGIBLE &&
      !hideDownloadBufflInWebSurvey &&
      !hideIllustrationsInWebSurvey ? (
        <>
          <img
            src={herdyStandingArm}
            alt="Herdy standing right arm"
            className={styles.herdyStandingArm}
          />
          <img
            src={herdySittingIcecream}
            alt="Herdy sitting with icecream"
            className={styles.herdySittingIcecream}
          />
        </>
      ) : null}
    </div>
  );
};
